import React from 'react';
import eventStyles from 'assets/css/Event.module.css';
import { IconClock, IconAngleRight, IconOrganizer } from '@ace/react-icons';
import { format } from 'date-fns-tz';
import PropTypes from 'prop-types';
import useHasEventTimePassed from 'Components/Card/helper/eventTimingHelpers';
import buttonStyles from 'assets/css/Button.module.css';
import { withCardLinkIconWrap } from 'Components/Card/CardLink';
import classNames from 'classnames';

const WrappedIconAngleRight = withCardLinkIconWrap(IconAngleRight);

const EventOrganizer = ({eventOrganizerDisplay}) => {
    if (!eventOrganizerDisplay)
        return false;

    return (
        <div className={eventStyles.organizerWrap}>
            <div className={eventStyles.organizerIcon}>
                <IconOrganizer />
            </div>
            <p className={eventStyles.organizerName}>
                {eventOrganizerDisplay}
            </p>
        </div>
    );
};

EventOrganizer.propTypes = {
    eventOrganizerDisplay: PropTypes.string
};

const EventDisplay = ({startDate, endDate, eventTitle, children}) => {
    return (
        <div className={eventStyles.event}>
            <div className={eventStyles.date}>
                {format(startDate, "MMM")}
                <span>{format(startDate, "dd")}</span>
            </div>
            <div className={eventStyles.info}>
                <h4 className={eventStyles.title}>{eventTitle}</h4>
                <div className={eventStyles.timeWrap}>
                    <div className={eventStyles.timeIcon}>
                        <IconClock />
                    </div>
                    <p className={eventStyles.timeText}>
                        {format(startDate, "iiii, MMMM dd")}<br/>
                        <span>{format(startDate, "h:mm a")} - {format(endDate, "h:mm a zzz")}</span>
                    </p>
                </div>
                {children}
            </div>
        </div>
    )
};

EventDisplay.propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    eventTitle: PropTypes.string.isRequired,
    children: PropTypes.node
};

const EventLaunchBtnContent = ({startDate, endDate, beforeEventText, duringEventText, afterEventText}) => {
    const hasStarted = useHasEventTimePassed(startDate);
    const hasEnded = useHasEventTimePassed(endDate);

    if (!hasStarted)
        return beforeEventText || "Scheduled";
    else if (hasStarted && !hasEnded) 
        return duringEventText || "Launch Class";
    else 
        return afterEventText || "Finished";
}

EventLaunchBtnContent.propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    beforeEventText: PropTypes.string.isRequired,
    duringEventText: PropTypes.string.isRequired,
    afterEventText: PropTypes.string
};

const EventLaunchBtn = ({href, additionalClassNames, children}) => {
    const classes = classNames(additionalClassNames, buttonStyles.stroke);

    return (
        <a className={classes} target="_blank" rel="noopener noreferrer" href={href}>
            {children}
            <WrappedIconAngleRight />
        </a>
    );
}

EventLaunchBtn.propTypes = {
    href: PropTypes.string.isRequired,
    additionalClassNames: PropTypes.string,
    children: PropTypes.node
};

const EventPartials = {
    EventDisplay, 
    EventLaunchBtnContent,
    EventLaunchBtn,
    EventOrganizer,
    WrappedIconAngleRight
};

export default EventPartials;